<div class="ab-list-item-inner flex w-100 activity-type--relationship">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-share-alt"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span> added a connection
       to
      <app-activity-target-link [target]="item.target">{{item?.target | fullName}}</app-activity-target-link>
    </div>
    <div class="details">
      <a [routerLink]="['/entity/view', item?.payload?.toEntity?.id]"
      queryParamsHandling="preserve"
      class="attached-user user-profile-link ml-0050">{{item?.payload?.toEntity | fullName}}</a>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
